import { cacheDom } from "../utils/QuerySelectors.js"
import { getRebuyData } from "../utils/Rebuy.js"
import { makeid } from "../utils/helpers.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="related-products"',
}

const initSwiper = (section, initProductTiles=true) => {
  if(initProductTiles) window.setupProductTiles(section.querySelectorAll('[product-tile]:empty'))
  return new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: 2.2,
    slidesPerGroup: 2,
    spaceBetween: section.querySelector(`[${qs.swiper}]`).classList.contains('container') ? 12 : 0,
    breakpoints: {
      320: {
        slidesPerView: 1.3,
        slidesPerGroup: 1,
      },
      600: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1440: {
        slidesPerView: section.querySelector(`[${qs.swiper}]`).classList.contains('container') ? 7 : 4,
        slidesPerGroup: 7,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}

const initProducts = (swiper) => {
  if(!swiper.classList.contains('swiper-initialized')) {
    const swiperWrapper = swiper.querySelector('.swiper-wrapper')
    const swiperInstance = initSwiper(swiper.closest(`[${qsAll.sections}]`))
    const flatlay = swiper.dataset.flatlay || 'true'
    getRebuyData((products) => {
      console.log(products)
      let filteredProducts = []
      let groupIds = []
      products.forEach(product => {
        const metafield = product.metafields.filter(m => m.key == 'product_group' && m.namespace == 'leftonfriday')[0]
        if(metafield && !groupIds.includes(metafield.value)) {
          groupIds.push(metafield.value)
          filteredProducts.push(product)
        } else if ((typeof metafield == 'undefined') || !metafield) {
          filteredProducts.push(product)
        }
      })
      filteredProducts = filteredProducts.slice(0, parseInt(swiper.dataset.limit))
      filteredProducts.forEach(product => {
        fetch(`/products/${product.handle}?view=data`)
        .then(response => {
          return response.json()
        })
        .then(result => {
          const id = `product-tile-${makeid(5)}` 
          swiperWrapper.innerHTML +=  `
            <div class="swiper-slide h-full">
              <div class="h-full"
                id="${id}"
                product-tile 
                json='${JSON.stringify(result).replace("'", "’")}'
                lazyload='true'
                columns_desktop='4'
                columns_tablet='3'
                columns_mobile='1.2'
                flatlay='${flatlay}'
              ></div>
            </div>`
          setTimeout(() => {
            window.setupProductTiles(swiperWrapper.querySelectorAll(`#${id}`))
            swiperInstance.update()
          }, 500)
        })
      })
    }, 
      swiper.dataset.rebuy.trim(), 
      location.href.includes('/cart') ? window.initialCart.items.map(item => item.product_id).join(',') : ((typeof window.productData != 'undefined') ? window.productData.id : ''), 
      40, 
      true
    )
  }
}

// const iObserver = new IntersectionObserver(items => {
//   if (items[0].isIntersecting) {
//     const swiper = items[0].target
//     if(!swiper.classList.contains('swiper-initialized')) {
//       const swiperWrapper = swiper.querySelector('.swiper-wrapper')
//       const swiperInstance = initSwiper(swiper.closest(`[${qsAll.sections}]`))
//       const flatlay = swiper.dataset.flatlay || 'true'
//       getRebuyData((products) => {
//         console.log(products)
//         let filteredProducts = []
//         let groupIds = []
//         products.forEach(product => {
//           const metafield = product.metafields.filter(m => m.key == 'product_group' && m.namespace == 'leftonfriday')[0]
//           if(metafield && !groupIds.includes(metafield.value)) {
//             groupIds.push(metafield.value)
//             filteredProducts.push(product)
//           } else if ((typeof metafield == 'undefined') || !metafield) {
//             filteredProducts.push(product)
//           }
//         })
//         filteredProducts = filteredProducts.slice(0, parseInt(swiper.dataset.limit))
//         filteredProducts.forEach(product => {
//           fetch(`/products/${product.handle}?view=data`)
//           .then(response => {
//             return response.json()
//           })
//           .then(result => {
//             const id = `product-tile-${makeid(5)}` 
//             swiperWrapper.innerHTML +=  `
//               <div class="swiper-slide h-full">
//                 <div class="h-full"
//                   id="${id}"
//                   product-tile 
//                   json='${JSON.stringify(result).replace("'", "’")}'
//                   lazyload='true'
//                   columns_desktop='4'
//                   columns_tablet='3'
//                   columns_mobile='2'
//                   flatlay='${flatlay}'
//                 ></div>
//               </div>`
//             setTimeout(() => {
//               window.setupProductTiles(swiperWrapper.querySelectorAll(`#${id}`))
//               swiperInstance.update()
//             }, 500)
//           })
//         })
//       }, 
//         swiper.dataset.rebuy.trim(), 
//         location.href.includes('/cart') ? window.initialCart.items.map(item => item.product_id).join(',') : ((typeof window.productData != 'undefined') ? window.productData.id : ''), 
//         40, 
//         true
//       )
//     }
//   }
// })

const initSection = (section) => {
  const swiper = section.querySelector(`[${qs.swiper}]`)
  const rebuyId = swiper ? swiper.dataset.rebuy : null
  const url = section.dataset.url
  if(typeof rebuyId != 'undefined' && rebuyId) {
    // iObserver.observe(swiper)
    initProducts(swiper)
  } else if(url) {
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const recommendations = new DOMParser().parseFromString(text, 'text/html').querySelector(`[${qsAll.sections}]`)

        if (recommendations && recommendations.innerHTML.trim().length) {
          section.innerHTML = recommendations.innerHTML
          initSwiper(section)
        }
      })
      .catch(e => {
        console.error(e)
      })
  } else {
    initSwiper(section, false)
  }
}
window.initRelatedProducts = initSection

export const setupRelatedProducts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}